import React from 'react';
import { Checkbox } from 'components/forms';
import { FieldRenderProps } from 'react-final-form';

export interface CheckboxWrapperInterface extends FieldRenderProps<string> {}

const CheckboxWrapper: React.FC<CheckboxWrapperInterface> = (props) => {
  const { input, meta, label, ...otherProps } = props;
  return <Checkbox label={label} {...input} {...otherProps} />;
};

export default CheckboxWrapper;
